import { IProduct, IProductTags } from './Product';
import { Nullable } from './Typescript-utils';

export enum CtaTypes {
  ASSOCIATION = 'cta_association',
  CTA = 'cta',
}

export interface ICtaAssociation {
  id: string;
  type: typeof CtaTypes.ASSOCIATION;
  attributes: {
    type: string;
    coordinates: Nullable<string[]>;
  };
  relationships: {
    cta: {
      data: Nullable<{
        type: string;
        id: string;
      }>;
    };
  };
}

export interface ICta {
  id: string;
  type: typeof CtaTypes.CTA;
  attributes: {
    text: string;
    url: string;
    thumbnail_url: Nullable<string>;
  };
}

export type IPostRelationships = ICtaAssociation | ICta | IProduct | IProductTags;
